import script from "./RagChatBotMsgComp.vue?vue&type=script&setup=true&lang=js"
export * from "./RagChatBotMsgComp.vue?vue&type=script&setup=true&lang=js"

import "./RagChatBotMsgComp.vue?vue&type=style&index=0&id=11c9bcb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c9bcb4"]])

export default __exports__